import dashboards from "./dashboards";
import apps from "./apps";
import pages from "./pages";
import analytics from "./analytics";
import userInterface from "./user-interface";

const navigation = [...dashboards, ...apps, ...analytics, ...pages];

export default navigation;
